import {initialUsersTable} from "./helper";
import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";

const initialState = {
    usersTable: initialUsersTable,
    sendVerificationEmailLoading: false,
    sendVerificationEmailOnlyLoading: false,
    sendVerificationSmsOnlyLoading: false,
    chageUserStatusLoading: false,
    deleteUserLoading: false,
    createUserLoading: false,
    modifyUserLoading: false,
    importUsersLoading: false,
    licenseSummary: null,
    licenseSummaryLoading: false,
    licensePackages: [],
    licensePackagesLoading: false,
};
const setUserManagementTable = (state, action) => updateObject(state, {
    usersTable: updateObject(
        state.usersTable,
        {[action.key]: action.value},
    ),
});

const setSendVerificationEmailLoading = (state, action) => updateObject(state, {
    sendVerificationEmailLoading: action.payload,
});

const setSendVerificationEmailOnlyLoading = (state, action) => updateObject(state, {
    sendVerificationEmailOnlyLoading: action.payload,
});

const setSendVerificationSmsOnlyLoading = (state, action) => updateObject(state, {
    sendVerificationSmsOnlyLoading: action.payload,
});

const setChangeUserStatusLoading = (state, action) => updateObject(state, {
    chageUserStatusLoading: action.payload,
});

const setDeleteUserLoading = (state, action) => updateObject(state, {
    deleteUserLoading: action.payload,
});

const setCreateUserLoading = (state, action) => updateObject(state, {
    createUserLoading: action.payload,
});

const setModifyUserLoading = (state, action) => updateObject(state, {
    modifyUserLoading: action.payload,
});

const setImportUsersLoading = (state, action) => updateObject(state, {
    importUsersLoading: action.payload,
});

const setLicenseSummary = (state, action) => updateObject(state, {
    licenseSummary: action.value,
});

const setLicenseSummaryLoading = (state, action) => updateObject(state, {
    licenseSummaryLoading: action.value,
});

const setLicensePackages = (state, action) => updateObject(state, {
    licensePackages: action.value,
});

const setLicensePackagesLoading = (state, action) => updateObject(state, {
    licensePackagesLoading: action.value,
});

const userManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_USER_MANAGEMENT_TABLE:
            return setUserManagementTable(state, action)
        case actionTypes.SEND_VERIFICATION_EMAIL:
            return setSendVerificationEmailLoading(state, action)
        case actionTypes.SEND_VERIFICATION_EMAIL_ONLY:
            return setSendVerificationEmailOnlyLoading(state, action)
        case actionTypes.SEND_VERIFICATION_SMS_ONLY:
            return setSendVerificationSmsOnlyLoading(state, action)
        case actionTypes.UPDATE_USER_STATUS:
            return setChangeUserStatusLoading(state, action)
        case actionTypes.DELETE_USER:
            return setDeleteUserLoading(state, action)
        case actionTypes.CREATE_USER:
            return setCreateUserLoading(state, action)
        case actionTypes.MODIFY_USER:
            return setModifyUserLoading(state, action)
        case actionTypes.IMPORT_USERS_FROM_EXCEL:
            return setImportUsersLoading(state, action)
        case actionTypes.GET_LICENSE_SUMMARY:
            if (action.key === 'data') {
                return setLicenseSummary(state, action)
            } else if (action.key === 'loading') {
                return setLicenseSummaryLoading(state, action)
            }
            return state
        case actionTypes.GET_LICENSE_PACKAGES:
            if (action.key === 'data') {
                return setLicensePackages(state, action)
            } else if (action.key === 'loading') {
                return setLicensePackagesLoading(state, action)
            }
            return state
        default:
            return state;
    }
};

export default userManagementReducer;